export const colors = {
  paper: '#F2F3EF', ink: '#242924', muted: '#596157', soft: '#E5E7E0',
  line: '#D0D4C9', rust: '#B84326', rustDark: '#94341E', graphite: '#202622',
  copper: '#EE855C', white: '#FFFFFF', green: '#3E6647',
};

export const fonts = {
  sans: 'Arial, Helvetica, sans-serif',
  mono: '"Courier New", monospace',
};
